export interface AsistenciaResumen {
  id: string;
  fecha: string;
  status: number;
}

export interface AsistenciaState {
  studentId: string | null;
  registros: AsistenciaResumen[];
  loading: boolean;
  error: string | null;
}

export const initialAsistenciaState: AsistenciaState = {
  studentId: null,
  registros: [],
  loading: false,
  error: null,
};
